import { NoticeText } from '../../component/notice-text/NoticeText';
import { OrderQuantityProps } from '../../component/notice-text/parts/OrderQuantity';

interface NoticeTextSectionProps {
  display: boolean;
  firstOrderDiscountAmount: number | null;
  orderQuantity: OrderQuantityProps | null;
  storeDealText: string | null;
}

export const NoticeTextSection = (props: NoticeTextSectionProps) => {
  const { display, firstOrderDiscountAmount, orderQuantity, storeDealText } = props;

  if (!display) {
    return null;
  }

  return (
    <>
      <NoticeText>
        {firstOrderDiscountAmount && <NoticeText.FirstOrder price={firstOrderDiscountAmount} />}
        {orderQuantity && (
          <NoticeText.OrderQuantity
            text={orderQuantity.text}
            display_recent_30days_note={orderQuantity.display_recent_30days_note}
          />
        )}
        {storeDealText && <NoticeText.StoreDeal text={storeDealText} />}
      </NoticeText>
    </>
  );
};
